import { Customer } from '../../customer/model/customer.model';
export class Payloc {
  //General Info
  public paymentNum: number;      //Payment Location
  // public customer: string;        //Customer Number
  public statusFlag: string;      //Status
  public payName: string;         //Payment Location Name
  public attentionName: string;   //Attention
  public addr1: string;
  public addr2: string;
  public city: string;
  public state: string;
  public zip: string;
  public country: string;
  public countryName: string;
  public phone: string;
  public fax: string;
  public email: string;
  public taxId: string;
  public contact: string;
  public dataInfo: string;        //Special Comment Information
  public specialFlag: string;
  public backOffice: string;
  public memberLevel: string;
  public memberLevelLabel: string;
  public acctMgr: string;         //Account Manager


  //General Info - Statement
  public mcontact: string;
  public maddr1: string;
  public maddr2: string;
  public mcity: string;
  public mstate: string;
  public mzip: string;
  public mcountry: string;
  public mphone: string;
  public mfax: string;
  public memail: string;
  public stateMethod: string;


  //Banking info
  public payMethod: string;
  public payCurr: string;
  public payCurr2: string;
  public payFlag: string;         //Threshold Flag
  public payThreshAmt: number;    //Threshold Amount
  public nationalId: number;


  //Banking info - primary
  public bankName: string;
  public beneName: string;
  public bankAcct: string;        //Account Number / IBAN
  public bankRoute: string;       //Destination ID / Routing Number / BIC
  public bankSwift: string;
  public bankId: number;
  public bankAddr1: string;
  public bankAddr2: string;
  public bankCity: string;
  public bankState: string;
  public bankZip: string;
  public bankCountry: string;
  public bankPhone: string;


  //Banking info - intermediary
  public intBankName: string;
  public intBankAcct: string;     //Account Number / IBAN
  public intBankRoute: string;    //Destination ID / Routing Number / BIC
  public intBankSwift: string;    //Intermediary Bank Swift
  public intBankId: number;
  public intBankAddr1: string;
  public intBankAddr2: string;
  public intBankCity: string;
  public intBankState: string;
  public intBankZip: string;
  public intBankCountry: string;
  public intBankPhone: string;

  //Audit
  public createDate: Date;
  public createId: string;
  public updateDate: Date;
  public updateId: string;
  public deleteDate: Date;
  public deleteId: string;
  public deleteReason: string;
  public reactivateDate: Date;
  public reactivateId: string;

  public customerNum: number;

  public customer: Customer;

  public validations;
}
